import { render } from "./TrimsTab.vue?vue&type=template&id=c61fc1b6"
import script from "./TrimsTab.vue?vue&type=script&lang=js"
export * from "./TrimsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__